export const images = {
  hero: 'https://cdn.magicpatterns.com/patterns/generated-images/79259e2b-4ce2-401d-ad19-f25238d254f6.jpg',
  story: 'https://cdn.magicpatterns.com/patterns/generated-images/8ef76084-53e0-4fbf-9e93-ad8c52ede709.jpg',
  souk: 'https://cdn.magicpatterns.com/patterns/generated-images/32c537d6-cf12-4ab0-9005-e64cd337f1ee.jpg',
  products: 'https://cdn.magicpatterns.com/patterns/generated-images/3c475e64-7143-404c-8b3f-9dddde0f2d34.jpg',
  ritual: 'https://cdn.magicpatterns.com/patterns/generated-images/6322ebc1-681d-4aa6-9b9e-52fc68f7a88c.jpg',
}
